<template>
  <div>
    <!--文字点击下载-->
    <span style="font-size: 13px;" v-if="textDownload" @click.stop="textdownload()">{{textName}}</span>
    <!--按钮点击下载-->
    <div v-if="downloadTem" class="button-bg by-button--primary cursor" :style="'width:' + width" @click.stop="download()">
      <span>{{name}}</span>
    </div>
    <!--批量收货-->
    <div v-if="isExport">
      <div v-if="!fileDialog && !ISTrackingNO">
      <div class="cargo-info-from-main grid">
            <label class="cargo-info-from__label">选择文件</label>
            <div class="flex">
            <!-- <el-upload
                  class="upload-demo"
                  :action="this.$api04+'/File/api/FileUpload/UploadExcel'"   
                  :headers="myHeaders"
                  :on-success="handleAvatarSuccess"
                  :data="upLoadData"
                  :show-file-list="false"
                  :file-list="fileList1"
                  :on-exceed="handleExceed"
                  :auto-upload="false"
                  ref="upload"
                  :on-change="handleChange"
                  :before-upload="beforeAvatarUpload">
                  <el-button class="default-btn"  slot="trigger" type="primary" >
                    <span style="font-size: 16px" >+</span>
                    <span>选择文件</span>
                  </el-button>
                </el-upload> -->
                <ByUpload 
              :exportType="exportType" 
              :autoUpload="false"
              nameLabel='选择上传'
              ref="upload"
              @handleAvatarSuccess='handleAvatarSuccess'></ByUpload>
            <label class="file-list" v-for="(item,index) in fileList1" :key="index"> {{item.name}}</label>
            </div>
        </div>


        <div class="lineBlueBtnW cursor mt16" style="padding: 0 8px; width: auto" @click="GetOne()">
          {{downloadTrackingNO?'下载导入跟踪号模板':'模板下载'}}
        </div>
        <!--批量导入跟踪号 downloadTrackingNO为true-->
       
       
        <div class="btn mt15 flex flex-space-end">
          <div class="cancelBtn cursor" @click="clearDialog">取消</div>
          <div class="lineBlueBtnW cursor" @click="importFile()">确定</div>
        </div>
        </div>
        <div v-if="fileDialog">
           <span>以下订单收货件数与下单数不符，请联系百运客服确认！</span>
            <table class="mt16">
              <template v-for="(item,index) in fileItem"  >
                <tr v-if="index%2==0" :key="index">
                  <td>{{item.WaybillNO}}</td>
                </tr>
              </template>
            </table>
            <div class="btn mt15 flex flex-space-end">
              <div class="cancelBtn cursor" @click="clearDialog">取消</div>
              <div class="lineBlueBtnW cursor" @click="getAPI()">继续收货</div>
            </div>
        </div>

        <div v-if="ISTrackingNO">
          <div class="input-top">
            选择导入文件：<span>{{exportType == "exp"?"快递跟踪号批量导入-"+getDates()+".xlsx":'FBA跟踪号批量导入-'+getDates()+'.xlsx'}}</span>  
            <div class="lineBlueBtnW cursor ml8">
              <ByUpload 
              :exportType="exportType" 
              nameLabel='重新上传'
              @handleAvatarSuccess='handleAvatarSuccess'></ByUpload></div>
          </div>
          <div class="mt8">
            解析结果：解析成功{{successTotal}}条，失败{{errorTotal}}条；确认导入之后，会自动过滤解析失败的数据。
            <table border="0" cellspacing="0" cellpadding="0" class="editTableBg mt8">
              <tr>
                <th>订单号</th>
                <th>运单号</th>
                <th>跟踪号</th>
                <th>解析结果</th>
                <th>失败原因</th>
              </tr>
              <template v-for="(item,index) in TrackingNOList"  >
                <tr :key="index" :class="{'redColor':item.IsOK}">
                  <td>{{item.WaybillNO}}</td>
                  <td>{{item.TransferNO}}</td>
                  <td>{{item.TrackingNO}}</td>
                  <td >{{item.IsOK ?'成功':'失败'}}</td>
                  <td>{{item.Msg}}</td>
                </tr>
              </template>
            </table>
          </div>
          <div class="btn mt15 flex flex-space-end">
              <div class="lineBlueBtnW cursor" @click="UpdateTrackingNOFileMore">确定导入</div>
              <div class="cancelBtn cursor ml8" @click="clearDialog">取消</div>
          </div>
        </div>
      
    </div>
    
  </div>
</template>

<script>
import {post} from "../../../ask/axios.js"
import { getCookie } from '@/utils/auth'
import Dialog from "../../dialog/Dialog.vue"
import ByUpload from './ByUpload.vue';
import {parseTime} from "@/utils/index"
import {downloadFile} from "@/utils/util";
export default {
  components:{Dialog,ByUpload},
  props: {
    //button下载名称
    name: {
      // 按钮名称
      type: String,
      default: "导出",
    },
    //button下载按钮
    downloadTem:{
      type:Boolean,
      default:false
    },
    //文字下载名称
    textName:{
      type:String,
      default:"下载"
    },
    textDownload:{
      type:Boolean,
      default:false
    },
    url:{
      type:String,
      default:""
    },
    dataParam:{
      type:Object,
      default: () => {
        return {};
      },
    },
    exportType:{
      type:String,
      default:"exp"
    },
    
    //导出
    isExport:{
      type:Boolean,
      default:false
    },
    //批量导入跟踪号
    downloadTrackingNO:{
      type:Boolean,
      default:false
    },
    //接口
    apiUrl:{
      type:String,
      default:()=>{
        return ""
      }
    },
    //下载下来的名称
    DownloadName:{
      type:String,
      default:()=>{
        return ""
      }
    },
    //全部附件集合
    filesUrl:{
      type:Array,
      default:()=>{
        return []
      }
    },
    width:{
      type:String,
      default:()=>{
        return "76px"
      }
    }
  },
  data() {
    return {
      api:{
        url:'',
        parma:'',
      },
      ///=-----------------------导出文件0----------------
      upLoadData:{
        UploadType:this.exportType == 'exp' ? 1 :2
      },
      fileList1:[],
      myHeaders: {
        ['X-JWT-SUPTOKEN']: getCookie("X-JWT-SUPTOKEN")
      },
      fileDialog:false,
      fileUrl:'',//文件上传地址
      fileName: '', // 文件名称
      fileItem:[],//上传文件集合
      ISTrackingNO:false,//导入返回列表信息显示
      TrackingNOList:[],//导入订单返回结果
      successTotal:0,
      errorTotal:0,
    };
  },
  computed: {

  },
  watch: {

  },
  created() {
    
  },
  mounted() {

  },
  methods: {
    getDates(){
      let date = new Date();
      return date.getFullYear().toString()+ (date.getMonth()+1).toString() + date.getDate().toString();
    },
  
    //关闭弹框
    clearDialog(){
      this.$emit('closeDialog', false);
    },
    //文字下载
    textdownload(){
      let ordUrl = this.$apiFileCloud + this.url
      let name = this.textName + parseTime(new Date(),('{y}-{m}-{d}')) + '.' + this.url.split('.')[1]
      this.expName(ordUrl, name);
    },
    //按钮下载
    download(){
      if(this.exportType == 'exp'){
        this.api.url = this.$api04 + "/ExpressSupplier/api/ExpOrder/ExportShipmentInfo";//"/ExpressSupplier/api/ExpOrder/UploadOrderFile"
        this.api.parma = this.dataParam
        post(this.api.url,this.api.parma).then(res =>{
          if(res.IsOK){
              let ordUrl = this.$apiFileCloud + res.Results;
              let name = "快递order_export_" + new Date();

              let mb = this.myBrowser();
              if ("IE" == mb) {
                this.expName(ordUrl, name);
              } else {
                this.expFile(ordUrl, name);
              }
          }else{
              this.$message({
                message: res.Message,
                type: 'error'
              });
          }
         
        })
      }

      if(this.exportType == 'fba'){
        this.api.url = this.$api04 + "/FBASupplier/api/FbaOrder/FBAExportOrder"
        this.api.parma = this.dataParam;
        post(this.api.url,this.api.parma).then(res =>{
          console.log("======fba订单地址--====",res);
          if(res.IsOK){
            let ordUrl = this.$apiFileCloud + res.Results.FileUrl;
            console.log("======fba订单地址--====",ordUrl);
            let name = "FBAorder_export_" + new Date();

            let mb = this.myBrowser();
            if ("IE" == mb) {
              this.expName(ordUrl, name);
            } else {
              this.expFile(ordUrl, name);
            }
          }else{
            this.$message({
                message: res.Message,
                type: 'error'
              });
          }
          
        })
      }
      //快递附件下载
      console.log("=======this.dataParam",this.dataParam);
      if(this.exportType == 'exp_annex' && this.dataParam.waybillNOs){
        //此接口返回为压缩包，暂时不用
        this.api.url = this.$api04 + "/ExpressSupplier/api/Exp/UploadOrderFiles"
        this.api.parma = this.dataParam
        post(this.api.url,this.api.parma).then(res =>{
          if(res.IsOK){
              let ordUrl = this.$apiFileCloud + res.Results;
              let name = "快递订单附件_" + new Date();

              let mb = this.myBrowser();
              if ("IE" == mb) {
                this.expName(ordUrl, name);
              } else {
                this.expFile(ordUrl, name);
              }
          }else{
              this.$message({
                message: res.Message,
                type: 'error'
              });
          }
         
        })
        
        // if(this.filesUrl.length > 0 ){
        //     this.filesUrl.forEach((item) =>{
        //       let ordUrl = this.$apiFileCloud + item.FullPath
        //       let name = item.BuildFileName
        //       this.expName(ordUrl, name);
              
        //   })
        // }
      }
      if(this.exportType == 'fba_annex' && this.dataParam.waybillNOs){
        //  if(this.filesUrl.length > 0 ){
        //     this.filesUrl.forEach((item) =>{
        //       let ordUrl = this.$apiFileCloud + item.FullPath
        //       let name = item.CurrentFileName
        //       this.expName(ordUrl, name);
              
        //   })
        // }
          this.api.url = this.$api04 + "/FBASupplier/api/FbaOrder/UploadOrderFiles"
          this.api.parma = this.dataParam
          post(this.api.url,this.api.parma).then(res =>{
            if(res.IsOK){
                let ordUrl = this.$apiFileCloud + res.Results;
                let name = "FBA订单附件_" + new Date();

                let mb = this.myBrowser();
                if ("IE" == mb) {
                  this.expName(ordUrl, name);
                } else {
                  this.expFile(ordUrl, name);
                }
            }else{
                this.$message({
                  message: res.Message,
                  type: 'error'
                });
            }
          })
      }
      if(this.exportType == 'bill'){
        this.api.url = this.$api04 + "/BillSupplier/api/SupplierBill/SupplierBillExport"
        this.api.parma = this.dataParam
        post(this.api.url,this.api.parma).then(res =>{
          if(res.IsOK){
              let ordUrl = this.$apiFileCloud + res.Results;
              let name = "账单_" + new Date();

              let mb = this.myBrowser();
              if ("IE" == mb) {
                this.expName(ordUrl, name);
              } else {
                this.expFile(ordUrl, name);
              }
          }else{
              this.$message({
                message: res.Message,
                type: 'error'
              });
          }
         
        })
      }
      if(this.exportType == 'accountLimit'){
        this.api.url = this.$api04 + "/RechargeSupplier/api/AccountCash/AccountCashUseLogExport"
        this.api.parma = this.dataParam
        post(this.api.url,this.api.parma).then(res =>{
          if(res.IsOK){
              let ordUrl = this.$apiFileCloud + res.Results;
              let name = "账户额度_" + new Date();

              let mb = this.myBrowser();
              if ("IE" == mb) {
                this.expName(ordUrl, name);
              } else {
                this.expFile(ordUrl, name);
              }
          }else{
              this.$message({
                message: res.Message,
                type: 'error'
              });
          }
         
        })
      }

      //公共：传接口地址apiurl 下载后的文件名称
      if(this.exportType =='public'){
        this.api.url = this.$api04 + this.apiUrl;
        this.api.parma = this.dataParam
        if(Object.keys(this.dataParam).length === 0){
          this.$message({
                message: '请选择一条导出',
                type: 'error'
              });
              return false;
        }
        post(this.api.url,this.api.parma).then(res =>{
          if(res.IsOK){
            let url = res.Results.FileUrl ? res.Results.FileUrl : res.Results
              let ordUrl = this.$apiFileCloud + url;
              let name = this.DownloadName + "_" + new Date().Format('yyyyMMdd')
              console.log("导出文件名称===",name);
              //let s = res.Results.split(',');

              downloadFile(ordUrl, name);
              // let mb = this.myBrowser();
              // if ("IE" == mb) {
              //   this.expName(ordUrl, name);
              // } else {
              //   this.expFile(ordUrl, name);
              // }
          }else{
              this.$message({
                message: res.Message,
                type: 'error'
              });
          }
         
        })
      }
      
    },
    //只区分浏览器，不考虑版本
    myBrowser() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return "IE"; // 因为ie10-ie11的版本问题，不再支持document.all判断，所以ie判断函数要重新写了
      }
    },
    //下载文件  不兼容ie
    expFile(url, fileName) {
      console.log("=====看看111===",fileName);
      // 创建隐藏的可下载链接
      var eleLink = document.createElement("a");
      eleLink.target = "_blank";
      eleLink.download = fileName+'.xls';
      eleLink.style.display = "none";
      eleLink.href = url;
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    //导出订单下载文件名修改并保存 兼容ie10+ 和 谷歌（Chrome）
    expName(url, filename) {
      console.log("=====看看===",filename);
      this.getBlob(url).then((blob) => {
        this.saveAs(blob, filename);
      });
    },
    getBlob(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    },
    saveAs(blob, filename) {
      console.log("=====看看===",filename);
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement("a");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();

        window.URL.revokeObjectURL(link.href);
      }
    },
    //----------------------模板下载---------------------
    //批量下单的模版下载
     GetOne(){
       let templateID = this.downloadTrackingNO ? -2 : -1
       let templateName = this.downloadTrackingNO ? (this.exportType == 'exp' ? '快递跟踪号批量导入.xlsx' : 'FBA跟踪号批量导入.xlsx') : '批量收货模板.xls'
      this.api.url = this.$api04 + '/ExpressSupplier/api/Exp/GetOne';
      this.api.parma = {
          "templateID": templateID,
      }
      post(this.api.url,this.api.parma).then(res=>{
        if(res.IsOK){
          let a = res.Results.Path;
          //this.expName( this.$apiFileCloud + 'uploadtest' + a,templateName);//res.Results.TemplateName)//区分大小的，uploadtest这个文件夹正式可能也不一样，正式需要修改配置
          this.expName(a,templateName);
        }
      })
    },

    ///=============================上传文件----------------
     //确定上传文件
    importFile(){
      let upload = this.$refs.upload
      
      console.log("======importFile",this.$refs.upload);
        let that=this
        
        if(upload.fileList1.length <=0 ){
          that.$confirm( '请选择你要导入的文件!','提示',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton:false,//去掉取消按钮
          showClose:false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => { 
          this.fileList1=[]
        }).catch(() => {

        });

          return false;
        }

      upload.$refs.upload.submit();　//手动上传文件触发按钮

    },
    //选择文件,上传成功后的操作
    handleAvatarSuccess(file,fileList){
      console.log("========file",fileList);
      this.fileUrl = file.Results.UploadPath;
      this.fileName = fileList[0].name;
      if(this.exportType == 'exp'){
        if(this.downloadTrackingNO){
          console.log('0000000000999999',);
          this.getTrackingNO(file.Results.UploadPath,1);
        }else{
          this.getAPI(file.Results.UploadPath);
        }
          
      }
      if(this.exportType == 'fba'){
        if(this.downloadTrackingNO){
          console.log('0000000000999999',);
          this.getTrackingNO(file.Results.UploadPath,2);
        }else{
          //fba批量上传
          this.getFbaData(file.Results.UploadPath);
          }
      }
        
    },
    getFbaData(url){
      console.log("=======上传成功之后返回的的地址",url);
      this.api.url = this.$api04 + '/FBASupplier/api/FBAReceipt/SupplierBatchReceiveGood';
      this.api.parma ={
         "attachUrl": url
      }
      post(this.api.url,this.api.parma).then(res =>{
        console.log("=======批量发货",res);
        if(res.IsOK){
          this.$emit('batchInfo',res.Results)
        }else{
          this.$confirm( res.Message,'提示',  {
                customClass:'custom-message-box', //自定义添加Class
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                showCancelButton:false,//去掉取消按钮
                showClose:false,//去掉右上角的取消（X）
                // type: 'warning',
                center: true
              }).then(() => { 
                 this.fileList1=[]
              }).catch(() => {
      
              });
               return false;
        }
      })

    },
    getAPI(url){
      console.log("======文件url=====",url);
            let that =this ;
            that.api.param={
              "path": url?url:this.fileUrl,
              "isCheck": url?true:false
            }
            that.api.url=  that.$api04 + "/ExpressSupplier/api/Exp/DoInStoreMore";
          post(that.api.url, that.api.param).then(function(file) {
            console.log("=====epx批量上传====",file);
             //接口数据
              if(!file.IsOK && file.ErrorCode == 'C0004'){//收货件数与下单件数不一致
                that.fileDialog = true;
                //that.clearDialog();
                that.fileItem = file.Result
              }else{
                console.log("=====url===",url);
                if(file.IsOK){
                  if(file.Result.length == 0 ){
                    that.getAPI();
                  }else{
                    that.$emit('batchInfo',file.Result)
                  }
                  
                }else{
                    that.$confirm( file.Message,'提示',  {
                    customClass:'custom-message-box', //自定义添加Class
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                    closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                    showCancelButton:false,//去掉取消按钮
                    showClose:false,//去掉右上角的取消（X）
                    // type: 'warning',
                    center: true
                  }).then(() => { 
                    that.fileList1=[]
                  }).catch(() => {
          
                  });
                  return false;
                  }
               
              }
              
      })
    },
    //批量导入跟踪号
    getTrackingNO(url,val){
       
       let that =this ;
           
            if(val == 1){
               that.api.param={
                  "path": url?url:this.fileUrl,
                }
                that.api.url=  that.$api04 + "/ExpressSupplier/api/Exp/UpdateTrackingNOFileCheck";
            }
            if(val == 2){
               that.api.param={
                  "path": url?url:this.fileUrl,
                }
              that.api.url=  that.$api04 + "/FBASupplier/api/FBASupOrder/UpdateTrackingNOFileCheck"
            }
          post(that.api.url, that.api.param).then(function(file) {
            console.log("批量导入跟踪号",file);
            let successTotal = 0;
            let errorTotal = 0;
             //接口数据
              
                that.ISTrackingNO = true
                that.TrackingNOList = file.Results
                if(file.Results){
                  file.Results.forEach(item =>{
                  if(item.IsOK){
                    successTotal++;
                  }else{
                    errorTotal++;
                  }
                })
                }else{
                   that.$confirm( file.Message,'提示',  {
                    customClass:'custom-message-box', //自定义添加Class
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                    closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                    showCancelButton:false,//去掉取消按钮
                    showClose:false,//去掉右上角的取消（X）
                    // type: 'warning',
                    center: true
                  }).then(() => { 
                    that.fileList1=[]
                  }).catch(() => {
          
                  });
                }
                that.successTotal = successTotal;
                that.errorTotal = errorTotal;

              
              
      })
    },
    //确定导入跟踪号
    UpdateTrackingNOFileMore(){
       let that =this ;
            that.api.param={
              "path": this.fileUrl//url?url:this.fileUrl,
             // "isCheck": url?true:false
            }
            if(this.exportType == 'fba'){
              that.api.url=  that.$api04 + "/FBASupplier/api/FBASupOrder/UpdateTrackingNOFileMore";
            }
            if(this.exportType == 'exp'){
              that.api.url=  that.$api04 + "/ExpressSupplier/api/Exp/UpdateTrackingNOFileMore";
            }
            
          post(that.api.url, that.api.param).then(function(file) {
            console.log("批量导入跟踪号",file);
             //接口数据
              if(!file.IsOK){
                   that.$confirm( file.Message,'提示',  {
                    customClass:'custom-message-box', //自定义添加Class
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                    closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                    showCancelButton:false,//去掉取消按钮
                    showClose:false,//去掉右上角的取消（X）
                    // type: 'warning',
                    center: true
                  }).then(() => { 
                    that.fileList1=[]
                  }).catch(() => {
          
                  });
              }else{  
                that.clearDialog();
                that.$message({
                message: "更新导入成功",
                  type: 'success'
                });        
              }
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning('上传文件大小不能超过2M')
    },
    //通过 on-change 钩子函数来对列表进行控制
    handleChange(file, fileList) {
      this.changeFile = true
      fileList.forEach((item)=>{
        if(item.status=='ready'){ //利用返回的状态控制
          this.fileList1 = fileList.slice(-1);
        }
      })
    },
    // 上传前对文件进行的判断
    beforeAvatarUpload(file) {
      const extension =' .xls, .xlsx, .csv, '
      var fileName = file.name ;
      var ext = fileName.substring(fileName.lastIndexOf('.'),fileName.length)+", ";

      if(extension.indexOf(ext)==-1)
      {
        this.$confirm( '导入文件只能是：'+extension+'格式!','提示',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton:false,//去掉取消按钮
          showClose:false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => { 
          this.fileList1=[]
        }).catch(() => {

        });
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2
      const isLtZeroM = file.size / 1024 / 1024 > 0
      if (!isLt2M) {
          this.$confirm( '上传文件大小超过2M限制！','提示',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton:false,//去掉取消按钮
          showClose:false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => { 
          this.fileList1=[]
        }).catch(() => {

        });
        
        return false;
      }
      if(!isLtZeroM){
          this.$confirm( '文件大小为0kb,请重新上传！','提示',  {
          customClass:'custom-message-box', //自定义添加Class
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
          closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
          showCancelButton:false,//去掉取消按钮
          showClose:false,//去掉右上角的取消（X）
          // type: 'warning',
          center: true
        }).then(() => { 
          this.fileList1=[]
        }).catch(() => {

        });
        return false;
      }

        
      // this.loading = this.$loading({
      //   lock: true,
      //   text: '正在处理中...',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });

      return true
    },
    //删除文件
    delFileLiat(){
      this.fileList1 = [];
      this.changeFile = false;
    },

  },
};
</script>

<style scoped lang="scss">
.v-modal{
  z-index: 2004;
}
.button-bg{
  background: #0046B9;
}
.cargo-info-from-main {
      box-sizing: border-box;
      // &::after {
      //   content: "";
      //   width: 100%;
      //   display: inline-block;
      //   height: 1px;
      //   border-bottom: 1px dashed #ddd;
      // }
  
      .cargo-info-from__label {
        margin: 8px 4px;
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;

        &::before {
          content: "";
          display: inline-block;
          position: relative;
          top: -3px;
          right: 4px;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: #d83f3f;
        }
      }
      .select-style{
        width: 272px;
      }
      .default-btn{
        width: 88px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 4px;
        line-height: 8px;
        font-size: 13px;
        padding: 0;
        span{
          color: #0046B9;
        }
      }
      .uploadBtn{
        border: 1px solid #0046B9;
        color: #0046B9;
      }
      .changeBtn{
        border: 1px solid #DDDDDD;
        color: #777777;
      }
      .file-list{
        color: #0046B9;
        font-size: 14px;
        margin: 0 8px;
      }
    }
    .minWigh{
      max-width: 100px;
      width: 100px !important;
    }
    .input-top{margin: -20px 0 20px;}
    .editTableBg{width:100%;font-size:14px;}
    .editTableBg tr{height: 40px;}
    .editTableBg tr th{font-size:14px;color:#333;border-bottom:1px solid #ddd;background:#f6f6f6;padding:2px 5px;}
    .editTableBg tr td{font-size:13px;color:#666;border-bottom:1px solid #ddd;padding:3px 5px;line-height:26px;word-break:break-all;color:#000;text-align: center;}
    .redColor{
      td{
        color: #d83f3f !important;
      }
    }
</style>
